module.exports = __webpack_public_path__ + "static/media/8-Hearts.e1156430.svg";